import { Flex, Text } from '@chakra-ui/react';
import { CampaignAnnouncement } from '@aslanpay/portal-common-lib';

import CenterSpinner from 'app/components/UI/CenterSpinner';
import { formatDateTime } from 'app/utils/table/campaigns';

interface CampaignAnnouncementsProps {
  announcements: CampaignAnnouncement[];
  isLoading: boolean;
}

/**
 * Every pride's winner for this cycle — the hall of fame.
 * <p>
 * A pride that announced nobody is absent rather than listed as empty, which is how the read answers, so
 * this is the winners and only the winners.
 */
function CampaignAnnouncements({ announcements, isLoading }: CampaignAnnouncementsProps) {
  if (isLoading) return <CenterSpinner />;

  if (announcements.length === 0) {
    return (
      <Text textStyle="smallRegular" color="brand.darkGray" data-testid="no-announcements">
        Nothing has been announced yet. Winners appear here once their announcement publishes.
      </Text>
    );
  }

  return (
    <Flex flexDir="column" gap="12px" data-testid="announcements">
      {announcements.map((announcement) => (
        <Flex
          key={`${announcement.campaignId}-${announcement.winnerId}`}
          flexDir="column"
          gap="2px"
          borderLeft="2px solid"
          borderColor="brand.lightGray1"
          pl="12px"
          data-testid={`announcement-${announcement.winnerId}`}
        >
          <Flex align="center" gap="8px" flexWrap="wrap">
            <Text textStyle="smallMedium" color="brand.black">
              {announcement.winnerName}
            </Text>
            {announcement.groupName && (
              <Text textStyle="extraSmallRegular" color="brand.darkGray">
                {announcement.groupName}
              </Text>
            )}
            <Text textStyle="extraSmallRegular" color="brand.darkGray">
              announced {formatDateTime(announcement.announcedAt)}
            </Text>
          </Flex>
          {announcement.winnerMessage && (
            <Text textStyle="smallRegular" color="brand.black">
              {announcement.winnerMessage}
            </Text>
          )}
        </Flex>
      ))}
    </Flex>
  );
}

export default CampaignAnnouncements;
